import { Tooltip, TooltipProvider, TooltipTrigger, TooltipContent } from '@components/atoms';
import * as React from 'react';

interface FilterChipProps {
	label: string;
	onRemove: () => void;
}

export const FilterChip: React.FC<FilterChipProps> = ({ label, onRemove }) => {
	const [isOverflowing, setIsOverflowing] = React.useState(false);
	const textRef = React.useRef<HTMLSpanElement>(null);

	// Check if text is overflowing (truncated)
	React.useEffect(() => {
		if (textRef.current) {
			setIsOverflowing(textRef.current.scrollWidth > textRef.current.clientWidth);
		}
	}, [label]);

	const chipContent = (
		<div
			data-aid="data-grid-filter-chip"
			className="flex items-center bg-white border border-tertiary rounded-[6px] px-2 py-0.5"
			style={{ maxWidth: '180px' }}
		>
			<span
				ref={textRef}
				className="text-xs font-medium text-primary truncate"
				style={{
					whiteSpace: 'nowrap',
					overflow: 'hidden',
					textOverflow: 'ellipsis',
				}}
			>
				{label}
			</span>
			<button onClick={onRemove} className="ml-1 text-base text-secondary hover:text-primary focus:outline-hidden">
				&times;
			</button>
		</div>
	);

	return (
		<TooltipProvider delayDuration={0} skipDelayDuration={0}>
			{isOverflowing ? (
				<Tooltip>
					<TooltipTrigger asChild>{chipContent}</TooltipTrigger>
					<TooltipContent>{label}</TooltipContent>
				</Tooltip>
			) : (
				chipContent
			)}
		</TooltipProvider>
	);
};
